import { BrowserModule }  from '@angular/platform-browser';
import { NgModule }       from '@angular/core';
import { FormsModule }    from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { HttpModule }     from '@angular/http';
import { NgbModule }      from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MdButtonModule, MdCardModule, MdMenuModule, MdToolbarModule, MdIconModule } from '@angular/material';
import { ResponsiveModule } from 'ng2-responsive';
import { Ng2PageScrollModule } from 'ng2-page-scroll';
import { Ng2DeviceDetectorModule } from 'ng2-device-detector';
import { AgmCoreModule } from '@agm/core';
import { TruncatePipe } from './truncate.pipe';

import { AppComponent } from './app.component';
import { NavigationComponent }  from './navigation.component';
import { TopDetailsComponent }  from './top-details.component';
import { TopGalleryComponent }  from './top-gallery.component';
import { DescriptionComponent }  from './description.component';
import { MenuComponent }  from './menu.component';
import { BookComponent } from './book.component';
import { EventsComponent } from './events.component';
import { ReviewsComponent } from './reviews.component';
import { ContactUsComponent } from './contact-us.component';
import { HomeComponent }  from './home.component';
import { EventBookComponent }  from './event-book.component';
import { BooknowComponent }  from './book-now.component';
import { ReviewListComponent }  from './review-list.component';
import { MenuListComponent }  from './menu-list.component';
import { BottomGalleryComponent } from './bottom-gallery.component';
import { TimetableLocationComponent } from './timetable-location.component'
import { FooterComponent } from './footer.component';
import { PromotionComponent } from './promotion/promotion.component';


import { RestaurantService }    from './restaurant.service';
import { MessageService }     from './message.service';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home',  component: HomeComponent  },
  { path: 'events',  component: EventsComponent},
  { path: '',  redirectTo: '/events',pathMatch: 'full' },
  { path: 'booknow',  component: BooknowComponent },
  { path: 'reviews', component: ReviewListComponent },
  { path: 'menu', component: MenuListComponent },
  { path: 'promotion', component: PromotionComponent },
  { path: 'contactus', component: ContactUsComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/app-routing.module.ts